<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <b-card-group>
            <b-card no-body class="p-4">
              <b-card-body>
                <b-form>
                  <center><img src="/img/logo.png" style="width: 150px;padding: 10px;"></center>
                  <h4 class="text-center">ลงชื่อเข้าใช้</h4>
                  <p class="text-muted text-center title">ลงชื่อเข้าใช้บัญชีคลินิกของ ZeekDoc</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="fas fa-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="ชื่อผู้ใช้" autocomplete="username email" v-model.trim="form.email"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="fas fa-key"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" class="form-control" placeholder="รหัสผ่าน" autocomplete="current-password" v-model.trim="form.password" @keyup.enter.native="login()"/>
                  </b-input-group>
                  <b-alert dismissible variant="danger" :show="alert.login.failed.active" @dismissed="alert.login.failed.active=false" class="text-center">{{alert.login.failed.textFailed}}</b-alert>
                  <b-row>
                    <b-col cols="12">
                      <b-button variant="primary" class="btn-block px-4" @click="login()"><i class="fas fa-sign-in-alt"></i> ลงชื่อเข้าใช้</b-button>
                    </b-col>
                    <b-col cols="12">
                      <a v-bind:href="url.reset.password+'password/email'" style="text-decoration: none"><b-button variant="link" class="btn-block px-0">ลืมรหัสผ่าน</b-button></a>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
    </div>
  </div>
</template>
<script>
import { Dashboard } from '@/router'
export default {
  data () {
    return {
      form: {
        email: null,
        password: null
      },
      url: {
        reset:{
          password: process.env.VUE_APP_AUTH_URL
        }
      },
      alert: {
        login: {
          failed:{
            active: false,
            textFailed: "ข้อมูลชื่อและรหัสผ่านของผู้ใช้ไม่พบในระบบ"
          }
        }  
      }
    }
  },
  methods: {
    async login () {
      let self = this
      self.$Progress.start()
      try {
        const res = await self.$http.post(process.env.VUE_APP_AUTH_URL+'api/v1/users/signin', {
          email: self.form.email,
          password: self.form.password
        })
        const autheWithToken = await this.authToken(res.data.token)
        if (autheWithToken) {
          localStorage.setItem('z_token', res.data.token)
          self.$router.replace({name: 'Dashboard'})
          self.$Progress.finish()
          self.alert.login.failed.active = false
        } else {
          self.$Progress.fail()
          self.alert.login.failed.active = true
        }
      } catch (error) {
        self.$Progress.fail()
        self.alert.login.failed.active = true
      }
    },
    async authToken(token) {
      try {
        const res = await this.$http.get(process.env.VUE_APP_API_URL + 'api/v1/users/me',
          { headers: { Authorization: 'Bearer '+token }})
        if(res.body.result === "success") {
          localStorage.setItem('z_site_url', res.body.json.site_url)
          return true
        } else {
          return false
        }
      } catch (error) {
        return false
      }
    }
  }
}
</script>
